import { Auth } from "../utils/Auth"

// const API_URL = 'http://localhost:8000' ?? 'http://localhost:8000'
// const API_URL = 'https://api.africasa.net' ?? 'https://api.africasa.net'
const API_URL = 'https://dev.africasa.net' ?? 'https://dev.africasa.net'
// const API_URL = process.env.REACT_APP_API_URL ?? 'http://localhost:8000'
// const API_URL = 'http://localhost:8000'
const API_PATH = 'api/admin'


const getHeaders = (isFormData = false) => {
    const headers = new Headers();
    
    if (!isFormData) {
      headers.append('Content-Type', 'application/json');
    }
    
    headers.append('Accept', 'application/json');
    headers.append('Connection', 'keep-alive');
    
    const token = Auth.getSessionToken();
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);
    }
    
    return headers;
};

const getHeadersData = (isFormData = false) => {
    const headers = new Headers();
    headers.append('Connection', 'keep-alive');
    
    // Ne pas mettre Content-Type pour FormData
    const token = Auth.getSessionToken();
    if (token) {
      headers.append('Authorization', `Bearer ${token}`);
    }
    
    return headers;
};

  

const get = (endpoint, signal=new AbortController().signal) => {
    return new Promise((resolve,reject) => {
        fetch(`${API_URL}/${API_PATH}/${endpoint}`,{
            headers:getHeaders(),
            method:'get',
            signal,
        })
        .then((response) => {
            if(!response.ok){
                return reject({
                    status:response.status,
                    messages:getResponseErrors(response)
                })
            }
            return response.json();
        })
        .then(result => {
            resolve(result)
        })
        .catch(error => reject(error))
    })
}

const post = (endpoint, payload='', signal = new AbortController().signal) =>{
    const isFormData = payload instanceof FormData;
    return fetch(`${API_URL}/${API_PATH}/${endpoint}`,
        {
            method:'post', 
            headers: getHeaders(isFormData), 
            body:payload,
            signal,
        })
        
        .then(async result => {
            if (!result.ok) {
                const errorData = await result.json();
                return errorData;
            } else {
                const data = await result.json();
                return data;
            }
        })
        .catch(error => {
            console.log(error)
            
        })
}

const update = (endpoint, payload='', signal = new AbortController().signal) =>{
    const isFormData = payload instanceof FormData;
    return fetch(`${API_URL}/${API_PATH}/${endpoint}`,
        {
            method:'put', 
            headers: isFormData ? getHeadersData(true) : getHeaders(), 
            body:payload,
            signal,
        })
        
        .then(async result => {
            if (!result.ok) {
                const errorData = await result.json();
                return errorData;
            } else {
                const data = await result.json();
                return data;
            }
        })
        .catch(error => {
            console.log(error)
        })
}

// const update = (endpoint, payload='', signal=new AbortController().signal) => {
//     return new Promise((resolve, reject) => {
//         fetch(`${API_URL}/${API_PATH}/${endpoint}`,
//         {
//             method:'post', 
//             headers:getHeaders(), 
//             body:payload,
//             signal
//         })
//         .then(response => {
//             if (!response.ok) {
//                 return reject({
//                     status: response.status,
//                     messages: getResponseErrors(response)
//                 });
//             } 

//             return response.json();
//         })
//         .then(result => {
//             resolve(result)
//         })
//         .catch(error => reject(error))
//     })
// }

const erase = (endpoint, signal = new AbortController().signal) => {
    return new Promise((resolve, reject) => {
        fetch(`${API_URL}/${API_PATH}/${endpoint}`,
        {
            method:'delete', 
            headers:getHeaders(), 
            signal
        })
        .then(response => {
            if (!response.ok) {
                return reject({
                    status: response.status,
                    messages: getResponseErrors(response)
                    });
            }

            return response.json();
        })
        .then(result => {
            resolve(result)
        })
        .catch(error => reject(error))
    })
}

const getResponseErrors = response => {
    return new Promise((resolve, reject) => {
        if (!response) reject(null);
        
        response.json().then(result => {
            let errorMessages = [];
            
            errorMessages.push(result.message);
    
            for (let error in result.errors) 
                errorMessages.push(result.errors[error]);

            resolve(errorMessages);
        });    
    })
}

const signin = (endpoint,payload, signal = new AbortController().signal) =>{
    return fetch(`${API_URL}/${API_PATH}/${endpoint}`,
        {
            method:'post', 
            headers:{
                'Content-type': 'application/json'
            },
            body:payload,
            signal,
            // mode: 'no-cors'
        })
        
        .then(async result => {
            if (!result.ok) {
                // Convertir la réponse en JSON si le statut n'est pas "ok"
                const errorData = await result.json();
                // console.log(errorData.message);  // Récupérer le message d'erreur
                return errorData;
            } else {
                // Si tout va bien, traiter la réponse
                const data = await result.json();
                // console.log(data);
                return data;
            }

        })
        .catch(error => {
            console.log(error)
        })
}

const signout = (endpoint, signal = new AbortController().signal) =>{
    return fetch(`${API_URL}/${API_PATH}/${endpoint}`,
        {
            method:'post', 
            headers:getHeaders(),
            signal,
            // mode: 'no-cors'
        })
        
        .then(async result => {
            if (!result.ok) {
                // Convertir la réponse en JSON si le statut n'est pas "ok"
                const errorData = await result.json();
                // console.log(errorData.message);  // Récupérer le message d'erreur
                return errorData;
            } else {
                // Si tout va bien, traiter la réponse
                const data = await result.json();
                // console.log(data);
                return data;
            }

        })
        .catch(error => {
            console.log(error)
        })
}

export const Api = {
    erase,
    update,
    post,
    get,
    signin,signout
}